// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FacebookOutlinedSvg from "@fishx/icons-svg/es/asn/FacebookOutlined";
import FishxIcon from '../components/FishxIcon';

var FacebookOutlined = function FacebookOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FacebookOutlinedSvg
  }));
};

FacebookOutlined.displayName = 'FacebookOutlined';
export default React.forwardRef(FacebookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FacebookOutlined.js
// module id = 2659
// module chunks = 0